<div class="">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">ثبت نام مالک شناور</h2>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submit()">
          <!-- phoneNumber field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('strMobile').value ? 'direction-ltr' : ''"
          >
            <span class="form-control-icon">
              <mat-icon>phone_iphone</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="strMobile"
              inputmode="numeric"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              placeholder="* شماره موبایل"
            />
          </div>

          <!-- name field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>account_circle</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="strName"
              placeholder="* نام"
              autofocus
            />
          </div>

          <!-- family field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>account_circle</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="strFamily"
              placeholder="* نام خانوادگی"
            />
          </div>

          <!-- nationalId field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('strID').value ? 'direction-ltr' : ''"
          >
            <span class="form-control-icon">
              <mat-icon>badge</mat-icon>
            </span>
            <input
              class="form-control"
              formControlName="strID"
              inputmode="numeric"
              maxlength="10"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              placeholder="* کد ملی مالک شناور"
            />
          </div>

          <!-- state field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>apartment</mat-icon>
            </span>
            <select (change)="getCities($event)">
              <option [value]="null" disabled selected>* استان</option>
              <option
                *ngFor="let state of states$ | async"
                [value]="state.strState"
              >
                {{ state.strStateName }}
              </option>
            </select>
          </div>

          <!-- city field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>apartment</mat-icon>
            </span>
            <select formControlName="strCity">
              <option [value]="null" disabled selected>* شهر</option>
              <option
                *ngFor="let city of cities$ | async"
                [value]="city.strCity"
              >
                {{ city.strCityName }}
              </option>
            </select>
          </div>

          <!-- نام تعاونی  -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon class="mat-18">houseboat</mat-icon>
            </span>
            <input
              class="w-100 mb-3 form-control"
              placeholder=" نام تعاونی"
              formControlName="strCooperativeName"
            />
          </div>

          <!-- floating type field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>directions_boat</mat-icon>
            </span>
            <select formControlName="tiFloatingType">
              <option [value]="null" disabled selected>* نوع شناور</option>
              <option
                *ngFor="let floatingType of floatingType$ | async"
                [value]="floatingType.tiFloatingType"
              >
                {{ floatingType.strFloatingType }}
              </option>
            </select>
          </div>

          <!-- برند موتور  -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon class="mat-18">anchor</mat-icon>
            </span>
            <input
              class="w-100 mb-3 form-control"
              placeholder=" برند موتور"
              formControlName="strMotorBrand"
            />
          </div>

          <!-- نوع موتور  -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon class="mat-18">anchor</mat-icon>
            </span>
            <input
              class="w-100 mb-3 form-control"
              placeholder=" نوع موتور"
              formControlName="strMotorType"
            />
          </div>

          <!-- floating power field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('iPower').value ? 'direction-ltr' : ''"
          >
            <span class="form-control-icon">
              <mat-icon>electric_bolt</mat-icon>
            </span>
            <input
              class="form-control"
              formControlName="iPower"
              inputmode="numeric"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              placeholder="* توان موتور شناور"
            />
          </div>

          <!-- map picker field-->
          <div class="form-group has-icon map-field-wrapper">
            <span class="form-control-icon">
              <mat-icon>add_location_alt</mat-icon>
            </span>

            <input
              class="form-control"
              formControlName="strAddress"
              [placeholder]="addressPlaceHolder"
            />

            <button
              type="button"
              class="btn btn-warning show-map-btn"
              (click)="show_Map()"
            >
              <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
            </button>

            <custom-map
              *ngIf="showMapDialog"
              [longLat]="[coordinates.fLon, coordinates.fLat]"
              [isOpenModal]="true"
              (mdl_Submit)="submitMap($event)"
            ></custom-map>
          </div>

          <!-- description field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>description</mat-icon>
            </span>
            <textarea
              class="form-control"
              formControlName="strComment"
              placeholder="مثلا: بهترین ساعت حضور کارشناس نصب و توضیحات تکمیلی..."
            ></textarea>
          </div>

          <!-- installment field -->
          <div class="d-none form-check form-switch my-3 d-flex align-items-center">
            <input
              class="form-check-input m-0"
              type="checkbox"
              id="bInstallment"
              formControlName="bInstallment"
            />
            <label
              class="form-check-label pointer text-muted me-2"
              for="bInstallment"
              >پرداخت اقساطی</label
            >
          </div>

          <!-- installment comment -->
          <div
            *ngIf="formGroup.get('bInstallment')?.value"
            class="form-group has-icon"
          >
            <span class="form-control-icon">
              <mat-icon>description</mat-icon>
            </span>
            <textarea
              class="form-control"
              formControlName="strPaymentComment"
              placeholder="توضیحات شرایط پرداخت ..."
            ></textarea>
          </div>
        </form>
      </div>

      <div class="modal-footer d-flex flex-row-reverse justify-content-end">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="
            formGroup.invalid || formGroup.pristine || isSubmitDisabled
          "
          (click)="form.ngSubmit.emit()"
        >
          ثبت اطلاعات
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Receipt Dialog -->

<ng-template #paymentReceiptDialog let-modal>
  <ng-container>
    <div class="modal-header">
      <h2 class="modal-title">ثبت شماره پیگیری فیش پرداختی</h2>

      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="mdl_Receipt">
        <p class="">شماره پیگیری را دقیقاً مطابق رسید وارد کنید.</p>

        <div
          class="form-group has-icon"
          [ngClass]="
            mdl_Receipt.get('iTrackingCode').value ? 'direction-ltr' : ''
          "
        >
          <span class="form-control-icon">
            <mat-icon>receipt</mat-icon>
          </span>
          <input
            class="form-control"
            formControlName="iTrackingCode"
            inputmode="numeric"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            placeholder="* شماره پیگیری فیش پرداختی "
          />
        </div>

        <!-- Deposited Amount -->
        <div
          class="form-group has-icon"
          [ngClass]="mdl_Receipt.get('iPayment1').value ? 'direction-ltr' : ''"
        >
          <span class="form-control-icon">
            <mat-icon>attach_money</mat-icon>
          </span>
          <input
            class="form-control"
            formControlName="iPayment1"
            inputmode="numeric"
            oninput="
              this.value = this.value
                .replace(/[^0-9]/g, '')
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            placeholder="* مبلغ واریزی (ریال) "
          />
        </div>

        <!-- installment field -->
        <div class="d-none form-check form-switch my-3 d-flex align-items-center">
          <input
            class="form-check-input m-0"
            type="checkbox"
            id="hasInstallment"
            formControlName="bInstallment"
          />
          <label
            class="form-check-label pointer text-muted me-2"
            for="hasInstallment"
            >پرداخت اقساطی</label
          >
        </div>

        <!-- installment comment -->
        <div
          *ngIf="mdl_Receipt.get('bInstallment')?.value"
          class="form-group has-icon"
        >
          <span class="form-control-icon">
            <mat-icon>description</mat-icon>
          </span>
          <textarea
            class="form-control"
            formControlName="strPaymentComment"
            placeholder="توضیحات شرایط پرداخت ..."
          ></textarea>
        </div>
      </form>
    </div>

    <div class="modal-footer d-flex justify-content-start">
      <button
        type="button"
        class="btn btn-success px-4"
        (click)="submitReceipt()"
      >
        ثبت اطلاعات
      </button>

      <button class="btn btn-outline-secondary px-4" (click)="modal.dismiss()">
        انصراف
      </button>
    </div>
  </ng-container>
</ng-template>
